import {Button} from "@heroui/button"

import TwitchClipsTable, {TableClip} from "@/components/DownloaderApp/TwitchClipsTable";
import React, {useEffect, useRef, useState} from "react";
import {setupCommunication} from "@/utils/setup-communication";
import {logger} from "@/components/DownloaderApp/logger";
import {ChromeExtensionPopup} from "@/components/DownloaderApp/ChromeExtensionPopup";
import {isDev, parseExtensionVersion} from "@/components/DownloaderApp/utils";
import {useModal} from "@/components/DownloaderApp/Modal";
import {Input} from "@heroui/input";
import {useQuery} from "@tanstack/react-query";
import Queue from "better-queue";
import MemoryStore from "better-queue-memory";
import {useMonitoring} from "@/components/monitoring";


function startDownloading(clips, folderName, cb) {
    return new Promise((resolve, reject) => {
        let totalDone = 0;
        const q = new Queue(
            async function ({clip}, cb) {
                try {
                    const fileName = `${folderName}/${clip.created_at.toISOString().split('T')[0]}-${(clip.id)}.mp4`;
                    const proxyUrl = `/api/download-twitch-clip?url=${clip.url}`;
                    const downloadUrl = (await fetch(proxyUrl).then(a => a.json())).downloadUrl;

                    const resss = await window.sendMessage("download-file", {
                        fileName,
                        url: downloadUrl
                    });
                    isDev && console.log({downloadUrl, resss});

                    cb(null, clip);
                } catch (err) {
                    cb({
                        err,
                        clip
                    });
                }


            },
            {
                setImmediate: (cb) => setTimeout(cb, 0),
                concurrent: 3,
                store: new MemoryStore(),
                maxRetries: 4,
                retryDelay: 1000 * 2,
                maxTimeout: 1000 * 15,
            }
        );

        clips.forEach(clip => q.push({clip}));

        q.on("task_finish", async function (taskId, result) {
            // console.log(taskId, result);
            totalDone++;
            cb(totalDone)
        })
        let errors = []
        q.on("task_failed", async function (taskId, err, stats) {
            console.log('ERR', {taskId, err, stats})
            errors.push(err)
        })


        q.on("drain", async function () {
            const queueStats = q.getStats();
            console.log('=== done > REAL PROGRESS', queueStats.total, clips.length, queueStats);
            if (queueStats.total === clips.length) {
                if (queueStats.successRate !== 1) {
                    reject(errors)
                } else {
                    resolve(true);
                    console.log('All clips downloaded!');
                }
            }
        });
    })
}

// CANT DOWN: https://my-app-staging.adasq3.workers.dev/api/download-twitch-clip?url=https://www.twitch.tv/xqc/clip/HeadstrongShyRabbitDBstyle-oDamOus3chS0p4Iq

export default function BulkTwitchDownload() {

    const [fileUrls, setFileUrls] = useState<TableClip[]>([]);
    const [extension, setExtension] = useState<string[]>(null);
    const [channel, setChannel] = useState<string>('');
    const [temporaryChannel, setTemporaryChannel] = useState<string>('zoewrenmusic');
    const [isDownloading, setIsDownloading] = useState(false);
    const [downloadProgress, setDownloadProgress] = useState(0);
    const shouldStopDownloadRef = useRef(false);
    const {show} = useModal()
    const { track } = useMonitoring()

    const {data: clips, isLoading, isError, refetch} = useQuery({
        queryKey: ['twitch-clips', channel],
        retry: false,
        queryFn: async () => {
            const response = await fetch(`/api/download-twitch-clip?channel=${channel}`);
            const clips = await response.json();
            if (!clips) throw new Error("Could not find clip channel");
            return clips;
        },
        enabled: !!channel,
    });

    async function promptChromeExtensionModal() {
        await show({
            component: ChromeExtensionPopup,
            data: {
                source: 'twitch-clips',
            }
        })
    }

    useEffect(() => {
        // setIsLoaded(true);
    });


    useEffect(() => {
        const {sendMessage} = setupCommunication({
            me: 'kick-video.download:webapp',
            them: 'kick-video.download:extension',
            expose: {
                'ping': () => 'pong from webapp'
            }
        })
        window.sendMessage = sendMessage;
        sendMessage('get-version').then(extension => {
            setExtension(extension);
            logger.log(`App version: ${extension.version}`);
        })
    }, []);


    async function verifyExtensionVersion() {
        if (!extension || parseExtensionVersion(extension.version).patch < 22) {
            promptChromeExtensionModal()
            throw new Error()
        }
    }

    const onClicked = async () => {
        track(`Twitch Bulk Download Init`, { channel, totalClips: fileUrls.length });
        setIsDownloading(true);
        setDownloadProgress(1);
        shouldStopDownloadRef.current = false;

        try {
            await verifyExtensionVersion();
            track(`Twitch Bulk Download Started`, { channel, totalClips: fileUrls.length });

            const folderName = `twitch-clips-${channel}-${Date.now()}`;

            // fileUrls[0].url =fileUrls[0].url+1

            const result = await startDownloading(fileUrls, folderName, setDownloadProgress);
            console.log({result})
            setTimeout(() => {
                track(`Twitch Bulk Download Finished`, { channel, totalClips: fileUrls.length });
                alert(`Successfully downloaded ${fileUrls.length} clips!`);
            }, 100);
        } catch (err) {
            console.log("FINAL EERR, ", err)
            const msg = `${err.map((err) => `${err.clip.no}. ${err.clip.title}`).join('\n')}`;

            track(`Twitch Bulk Download Error`, { channel, error: msg });
            alert(`Failed to fetch:
${msg}`)
        } finally {
            setIsDownloading(false);
            setDownloadProgress(0);
            shouldStopDownloadRef.current = false;
        }
    };

    async function onChannelSelected() {
        await verifyExtensionVersion();
        setChannel(temporaryChannel);
    }

    useEffect(() => {
        if (isError) {
            setChannel('')
            alert("Error fetching clips. Please make sure the channel name is correct.");
        }

    }, [clips, isError, channel]);

    const isLoaded = !!clips?.length;

    return <div className={"flex flex-col gap-6"}>

        {!isLoaded && (
            <>
                <Input onValueChange={(value) => setTemporaryChannel(value)} value={temporaryChannel} variant="bordered"
                       isRequired size={"lg"} label="Twitch channel " placeholder="Enter your email"/>
                <Button isDisabled={!temporaryChannel || isLoading} isLoading={isLoading} onPress={onChannelSelected}
                        color={"primary"}><span>Start downloading</span></Button>
            </>
        )}

        {isLoaded && <TwitchClipsTable clips={clips} onSlugsChanged={setFileUrls}/>}
        {isLoaded && (
            <div className="flex gap-2 flex-col">
                <Button className={"w-full"} isDisabled={!fileUrls.length || isDownloading} isLoading={isDownloading}
                        onPress={onClicked} color={"primary"}>
                    <span>{isDownloading ? `Downloading (${downloadProgress}/${fileUrls.length})` : `Download all clips${fileUrls.length ? ` (${fileUrls.length} in total)` : ''}`}</span>
                </Button>
                {/*{isDownloading && (*/}
                {/*    <Button onPress={() => shouldStopDownloadRef.current = true} color={"danger"}>*/}
                {/*        Stop*/}
                {/*    </Button>*/}
                {/*)}*/}
            </div>
        )}


    </div>
}
